var map = {
	"./anniversearkhe.png": 81,
	"./arbalest.png": 82,
	"./argano.png": 83,
	"./arkhe.png": 84,
	"./arkhe2.png": 85,
	"./artemis.png": 86,
	"./baphomet.png": 87,
	"./callisto.png": 88,
	"./cameleon.png": 89,
	"./castel.png": 90,
	"./cronus.png": 91,
	"./daidalos.png": 92,
	"./echelon.png": 93,
	"./felos.png": 94,
	"./gargoyle.png": 95,
	"./gropho.png": 96,
	"./gropho_reward.png": 97,
	"./helix.png": 98,
	"./hermes.png": 99,
	"./hydra.png": 100,
	"./ictus.png": 101,
	"./ikarus.png": 102,
	"./intakt.png": 103,
	"./kain.png": 104,
	"./laird.png": 105,
	"./legatus.png": 106,
	"./lithus.png": 107,
	"./locust.png": 108,
	"./mesmer.png": 109,
	"./mesmer_reward.png": 110,
	"./metis.png": 111,
	"./onyx.png": 112,
	"./prometheus.png": 113,
	"./riveler.png": 114,
	"./sequer.png": 115,
	"./seth.png": 116,
	"./seth_reward.png": 117,
	"./symbiont.png": 118,
	"./termis.png": 119,
	"./troiar.png": 120,
	"./tyrannos.png": 121,
	"./vagabond.png": 122,
	"./vektor.png": 123,
	"./waspish.png": 124,
	"./yagel.png": 125,
	"./zenith.png": 126
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;


//////////////////
// WEBPACK FOOTER
// ./src/images/bot_icons ^\.\/.*\.png$
// module id = 80
// module chunks = 0